import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
(function(IProductPageResponse) {
    (function(IPdpProduct) {
        (function(IVisuals) {
            IVisuals.build = function(partial) {
                return _object_spread({
                    badges: [],
                    images: [],
                    videos: []
                }, partial !== null && partial !== void 0 ? partial : {});
            };
        })(IPdpProduct.IVisuals || (IPdpProduct.IVisuals = {}));
        (function(IPurchaseInformation) {
            IPurchaseInformation.build = function(partial) {
                return _object_spread({
                    tester_prices: [],
                    style_groups: {},
                    customizations: []
                }, partial !== null && partial !== void 0 ? partial : {});
            };
        })(IPdpProduct.IPurchaseInformation || (IPdpProduct.IPurchaseInformation = {}));
        (function(IDetails) {
            (function(IProductInformationSubSection) {
                (function(ILink) {
                    ILink.build = function(partial) {
                        return _object_spread({}, partial !== null && partial !== void 0 ? partial : {});
                    };
                })(IProductInformationSubSection.ILink || (IProductInformationSubSection.ILink = {}));
                (function(Type) {
                    Type["TYPE_UNKNOWN"] = "TYPE_UNKNOWN";
                    Type["DESCRIPTION"] = "DESCRIPTION";
                    Type["DETAILS"] = "DETAILS";
                    Type["SAFETY_INFORMATION"] = "SAFETY_INFORMATION";
                    Type["ECO_FRIENDLY"] = "ECO_FRIENDLY";
                })(IProductInformationSubSection.Type || (IProductInformationSubSection.Type = {}));
                (function(IUserTranslatedAttribute) {
                    IUserTranslatedAttribute.build = function(partial) {
                        return _object_spread({}, partial !== null && partial !== void 0 ? partial : {});
                    };
                })(IProductInformationSubSection.IUserTranslatedAttribute || (IProductInformationSubSection.IUserTranslatedAttribute = {}));
                (function(IProductInformationSubSectionEntry) {
                    IProductInformationSubSectionEntry.build = function(partial) {
                        return _object_spread({}, partial !== null && partial !== void 0 ? partial : {});
                    };
                })(IProductInformationSubSection.IProductInformationSubSectionEntry || (IProductInformationSubSection.IProductInformationSubSectionEntry = {}));
                (function(IOptionLevelEntries) {
                    IOptionLevelEntries.build = function(partial) {
                        return _object_spread({
                            entries: []
                        }, partial !== null && partial !== void 0 ? partial : {});
                    };
                })(IProductInformationSubSection.IOptionLevelEntries || (IProductInformationSubSection.IOptionLevelEntries = {}));
                (function(IModalInformationSection) {
                    (function(IAttributeValueDetail) {
                        IAttributeValueDetail.build = function(partial) {
                            return _object_spread({}, partial !== null && partial !== void 0 ? partial : {});
                        };
                    })(IModalInformationSection.IAttributeValueDetail || (IModalInformationSection.IAttributeValueDetail = {}));
                    IModalInformationSection.build = function(partial) {
                        return _object_spread({
                            value_details: []
                        }, partial !== null && partial !== void 0 ? partial : {});
                    };
                })(IProductInformationSubSection.IModalInformationSection || (IProductInformationSubSection.IModalInformationSection = {}));
                IProductInformationSubSection.build = function(partial) {
                    return _object_spread({
                        entries: [],
                        option_level_entries_by_option_token: {},
                        modal_information_sections: []
                    }, partial !== null && partial !== void 0 ? partial : {});
                };
            })(IDetails.IProductInformationSubSection || (IDetails.IProductInformationSubSection = {}));
            (function(IProductInformationSectionGroup) {
                IProductInformationSectionGroup.build = function(partial) {
                    return _object_spread({
                        sections: []
                    }, partial !== null && partial !== void 0 ? partial : {});
                };
            })(IDetails.IProductInformationSectionGroup || (IDetails.IProductInformationSectionGroup = {}));
            IDetails.build = function(partial) {
                return _object_spread({
                    attribute_tags: [],
                    product_option_measurements: {},
                    product_information_section_groups: []
                }, partial !== null && partial !== void 0 ? partial : {});
            };
        })(IPdpProduct.IDetails || (IPdpProduct.IDetails = {}));
        (function(IMessages) {
            IMessages.build = function(partial) {
                return _object_spread({
                    info_texts: [],
                    disclaimers: []
                }, partial !== null && partial !== void 0 ? partial : {});
            };
        })(IPdpProduct.IMessages || (IPdpProduct.IMessages = {}));
        (function(IShippingInformation) {
            IShippingInformation.build = function(partial) {
                return _object_spread({}, partial !== null && partial !== void 0 ? partial : {});
            };
        })(IPdpProduct.IShippingInformation || (IPdpProduct.IShippingInformation = {}));
        IPdpProduct.build = function(partial) {
            return _object_spread({
                options: {},
                board_tokens: [],
                promoted_by: []
            }, partial !== null && partial !== void 0 ? partial : {});
        };
    })(IProductPageResponse.IPdpProduct || (IProductPageResponse.IPdpProduct = {}));
    (function(IPdpBrand) {
        IPdpBrand.build = function(partial) {
            return _object_spread({
                active_promo_collections: []
            }, partial !== null && partial !== void 0 ? partial : {});
        };
    })(IProductPageResponse.IPdpBrand || (IProductPageResponse.IPdpBrand = {}));
    IProductPageResponse.build = function(partial) {
        return _object_spread({}, partial !== null && partial !== void 0 ? partial : {});
    };
})(IProductPageResponse || (IProductPageResponse = {}));
export var IProductPageResponse;
